import trustPartnerBanner from '../../../assets/trust-partner-banner.png';
import { LinkedText } from '../../../components/LinkedText';

const trustItems = [
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Bank-Level 256-bit Encryption',
    desc: 'All player data and financial transactions are protected with military-grade SSL encryption — the same standard used by leading global financial institutions.',
  },
  {
    icon: 'ri-award-line',
    title: 'Internationally Licensed & Regulated',
    desc: 'MrCuci holds valid gaming licenses from internationally recognised regulatory bodies, ensuring full compliance with fair play standards and player protection laws.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Certified Fair RTP Rates',
    desc: 'All game RTP (Return to Player) percentages are independently tested and certified. We display transparent payout rates so you can always make informed decisions.',
  },
  {
    icon: 'ri-time-line',
    title: 'Guaranteed Fast Withdrawals',
    desc: 'Your winnings are processed within minutes — not days. We support dozens of local payment methods and maintain 100% transparent withdrawal policies with zero hidden fees.',
  },
];

export default function TrustSection() {
  return (
    <section
      id="why-trust-ausclub"
      style={{ background: 'linear-gradient(135deg, #0d0101 0%, #180303 50%, #0d0101 100%)' }}
      className="py-24"
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-[#d4a017]/10 border border-[#d4a017]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-shield-check-fill text-[#d4a017] text-xs" />
            </span>
            <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">Trust &amp; Safety</span>
          </div>
          <h2 className="text-4xl font-black text-white mb-4">
            Why Trust{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(135deg, #d4a017, #f5c518)' }}
            >
              MrCuci?
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm leading-relaxed">
            <LinkedText>
              Trust is earned, not given. At MrCuci, every decision we make is guided by a single mission: to give you the safest, fairest, and most rewarding casino experience possible.
            </LinkedText>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Trust list */}
          <div>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Our commitment to transparency, fairness, and responsible gaming has earned the trust of hundreds of
              thousands of players.{' '}
              <a href="/about/" className="text-[#d4a017] hover:underline">Learn more about us</a> and explore our
              full{' '}
              <a href="/games/" className="text-[#d4a017] hover:underline">game collection</a> powered by the world's
              top software providers.
            </p>

            <div className="space-y-5">
              {trustItems.map((item) => (
                <div
                  key={item.title}
                  className="flex gap-4 p-4 rounded-xl border border-[#d4a017]/10 hover:border-[#d4a017]/30 transition-all duration-300"
                  style={{ background: 'linear-gradient(135deg, #1a0303, #220404)' }}
                >
                  <div
                    className="w-11 h-11 flex items-center justify-center shrink-0 rounded-lg"
                    style={{ background: 'linear-gradient(135deg, rgba(204,17,0,0.3), rgba(212,160,23,0.25))', border: '1px solid rgba(212,160,23,0.25)' }}
                  >
                    <i className={`${item.icon} text-[#d4a017] text-xl`} />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-sm mb-1">{item.title}</h3>
                    <p className="text-gray-500 text-xs leading-relaxed"><LinkedText>{item.desc}</LinkedText></p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute -inset-px rounded-2xl opacity-40"
                style={{ background: 'linear-gradient(135deg, #d4a017, #cc1100, #d4a017)' }} />
              <img
                src={trustPartnerBanner}
                alt="MrCuci trusted partner in pokies and profit"
                className="relative w-full max-w-md h-auto object-top rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
